import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import GTMPageView from "@/components/GTMPageView";
import { BookingProvider } from "@/contexts/BookingContext";
import { WarningPopupProvider } from "@/contexts/WarningPopupContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Index from "./pages/Index";

// Lazy load non-critical pages to reduce initial bundle
const Ansiedade = lazy(() => import("./pages/Ansiedade"));
const Agendar = lazy(() => import("./pages/Agendar"));
const Horarios = lazy(() => import("./pages/Horarios"));
const Confirmacao = lazy(() => import("./pages/Confirmacao"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <BookingProvider>
          <WarningPopupProvider>
          <GTMPageView />
          <Suspense fallback={<div className="min-h-screen bg-background" />}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/sobre" element={<Index section="sobre" />} />
              <Route path="/servicos" element={<Index section="servicos" />} />
              <Route path="/localizacao" element={<Index section="localizacao" />} />
              <Route path="/aviso" element={<Index />} />
              <Route path="/agendar" element={<Agendar />} />
              <Route path="/horarios" element={<Horarios />} />
              <Route path="/confirmacao" element={<Confirmacao />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/ansiedade" element={<Ansiedade />} />
              <Route path="/ansiedade/sobre" element={<Ansiedade section="sobre" />} />
              <Route path="/ansiedade/servicos" element={<Ansiedade section="servicos" />} />
              <Route path="/ansiedade/localizacao" element={<Ansiedade section="localizacao" />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          </WarningPopupProvider>
        </BookingProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
